import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { RiDeleteBin5Line } from "react-icons/ri";

const ShowData = ({ showModal, handleClose }) => {
  const [inputValuer, setInputValuer] = useState('');
  const [inputValuing, setInputValuing] = useState('');

  const inputStyler = {
    padding: '8px',
    fontSize: '1rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
    outline: 'none',
    width: '195px',
    height: "35px",
    marginLeft:"140px"
  };
  const inputStyleing = {
    padding: '8px',
    fontSize: '1rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
    outline: 'none',
    width: '195px',
    height: "35px",
    marginLeft:"20px"
  };

  return (
    <div>
      <Modal show={showModal} onHide={handleClose} dialogClassName="modal-90w" size="lg">
        <Modal.Header closeButton style={{ backgroundColor: '#004aad' }}>
          <Modal.Title className='heading' style={{ color: 'white' }}>Case Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <br />
            <input
              type="text"
              value={inputValuer}
              onChange={(event) => setInputValuer(event.target.value)}
              style={inputStyler}
              placeholder=""
            />
            <input
              type="text"
              value={inputValuing}
              onChange={(event) => setInputValuing(event.target.value)}
              style={inputStyleing}
              placeholder=""
            />
            <Button style={{ border: "1px solid", backgroundColor: "#004aad",marginLeft:"10px" }}><RiDeleteBin5Line /></Button>
            <br /><br />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
            style={{ backgroundColor: '#004aad', borderColor: '#004aad' }}
          >
            Add
          </Button>
          <Button
            variant="secondary"
            onClick={handleClose}
            style={{ backgroundColor: '#004aad', borderColor: '#004aad' }}
          >
            Cancel
          </Button>
          <Button
            variant="secondary"
            onClick={handleClose}
            style={{ backgroundColor: '#004aad', borderColor: '#004aad' }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ShowData;
